module.exports = __webpack_public_path__ + "share.svg";